//@flow
import React from 'react'
import { asyncComponent } from 'react-async-component'
import Loading from '../components/LoadingComponent'
import ErrorComponent from '../components/ErrorComponent'

const LoadingComponent = () =>
  <Loading fullscreen>
    <h3 style={{ color: 'white' }}>Loading...</h3>
  </Loading>

const QuizScreen = asyncComponent({
  resolve: () => import('./Quiz'),
  LoadingComponent,
  ErrorComponent,
  ssrMode: 'defer',
  name: 'AsyncQuizScreen',
})
const StartScreen = asyncComponent({
  resolve: () => import('./Start'),
  LoadingComponent,
  ErrorComponent,
  ssrMode: 'defer',
  name: 'AsyncStartScreen',
})
const CompleteScreen = asyncComponent({
  resolve: () => import('./Complete'),
  LoadingComponent,
  ErrorComponent,
  ssrMode: 'defer',
  name: 'AsyncCompleteScreen',
})
const InformationScreen = asyncComponent({
  resolve: () => import('./Information'),
  LoadingComponent,
  ErrorComponent,
  ssrMode: 'defer',
  name: 'AsyncInformationScreen',
})
const InstructionsScreen = asyncComponent({
  resolve: () => import('./Instructions'),
  LoadingComponent,
  ErrorComponent,
  ssrMode: 'defer',
  name: 'AsyncInstructionsScreen',
})
const CommencementCheckScreen = asyncComponent({
  resolve: () => import('./CommencementCheck'),
  LoadingComponent,
  ErrorComponent,
  ssrMode: 'defer',
  name: 'AsyncCommencementCheckScreen',
})
const LearnerFormScreen = asyncComponent({
  resolve: () => import('./LearnerForm'),
  LoadingComponent,
  ErrorComponent,
  ssrMode: 'defer',
  name: 'AsyncLearnerFormScreen',
})
const DeclarationScreen = asyncComponent({
  resolve: () => import('./Declaration'),
  LoadingComponent,
  ErrorComponent,
  ssrMode: 'defer',
  name: 'AsyncDeclarationScreen',
})
const WelcomeBackScreen = asyncComponent({
  resolve: () => import('./WelcomeBack'),
  LoadingComponent,
  ErrorComponent,
  ssrMode: 'defer',
  name: 'AsyncWelcomeBackScreen',
})
const IntermissionScreen = asyncComponent({
  resolve: () => import('./Intermission'),
  LoadingComponent,
  ErrorComponent,
  ssrMode: 'defer',
  name: 'AsyncIntermissionScreen',
})
const MissScreen = asyncComponent({
  resolve: () => import('./Miss'),
  LoadingComponent,
  ErrorComponent,
  ssrMode: 'defer',
  name: 'AsyncMissScreen',
})
const ErrorScreen = asyncComponent({
  resolve: () => import('./Error'),
  LoadingComponent,
  ErrorComponent,
  ssrMode: 'defer',
  name: 'AsyncErrorScreen',
})
const InvalidInviteScreen = asyncComponent({
  resolve: () => import('./InvalidInvite'),
  LoadingComponent,
  ErrorComponent,
  ssrMode: 'defer',
  name: 'AsyncInvalidInviteScreen',
})
const QuizDisabledScreen = asyncComponent({
  resolve: () => import('./QuizDisabled'),
  LoadingComponent,
  ErrorComponent,
  ssrMode: 'defer',
  name: 'AsyncQuizDisabledScreen',
})
const TrialQuizDisabledScreen = asyncComponent({
  resolve: () => import('./TrialQuizDisabled'),
  LoadingComponent,
  ErrorComponent,
  ssrMode: 'defer',
  name: 'AsyncTrialQuizDisabledScreen',
})
const QuizTypeDisabledScreen = asyncComponent({
  resolve: () => import('./QuizTypeDisabled'),
  LoadingComponent,
  ErrorComponent,
  ssrMode: 'defer',
  name: 'AsyncQuizTypeDisabledScreen',
})

const DlrqStartScreen = asyncComponent({
  resolve: () => import('./DlrqStart'),
  LoadingComponent,
  ErrorComponent,
  ssrMode: 'defer',
  name: 'AsyncDlrqStartScreen',
})
const QuizCompleteScreen = asyncComponent({
  resolve: () => import('./QuizComplete'),
  LoadingComponent,
  ErrorComponent,
  ssrMode: 'defer',
  name: 'AsyncQuizCompleteScreen',
})
const QuizLearnerFormScreen = asyncComponent({
  resolve: () => import('./QuizLearnerForm'),
  LoadingComponent,
  ErrorComponent,
  ssrMode: 'defer',
  name: 'AsyncQuizLearnerFormScreen',
})
const DlrqInfoScreen = asyncComponent({
  resolve: () => import('./DlrqInfo'),
  LoadingComponent,
  ErrorComponent,
  ssrMode: 'defer',
  name: 'AsyncDlrqInfoScreen',
})

const DpStartScreen = asyncComponent({
  resolve: () => import('./DigitalProficiency/DpStart'),
  LoadingComponent,
  ErrorComponent,
  ssrMode: 'defer',
  name: 'AsyncDpStartScreen',
})
const DpLearnerFormScreen = asyncComponent({
  resolve: () => import('./DigitalProficiency/DpLearnerForm'),
  LoadingComponent,
  ErrorComponent,
  ssrMode: 'defer',
  name: 'AsyncDpLearnerFormScreen',
})

const DpQuizScreen = asyncComponent({
  resolve: () => import('./DigitalProficiency/DpQuiz'),
  LoadingComponent,
  ErrorComponent,
  ssrMode: 'defer',
  name: 'AsyncDpQuizScreen',
})

const DpInfoScreen = asyncComponent({
  resolve: () => import('./DigitalProficiency/DpInfo'),
  LoadingComponent,
  ErrorComponent,
  ssrMode: 'defer',
  name: 'AsyncDpInfoScreen',
})

const DpConfirmResetScreen = asyncComponent({
  resolve: () => import('./DigitalProficiency/DpConfirmReset'),
  LoadingComponent,
  ErrorComponent,
  ssrMode: 'defer',
  name: 'AsyncDpConfirmResetScreen',
})

const DlrqLearnerFormScreen = asyncComponent({
    resolve: () => import('./DlrqLearnerForm'),
    LoadingComponent,
    ErrorComponent,
    ssrMode: 'defer',
    name: 'AsyncDlrqLearnerFormScreen',
  })
  
const DlrqCompleteScreen = asyncComponent({
    resolve: () => import('./DlrqComplete'),
    LoadingComponent,
    ErrorComponent,
    ssrMode: 'defer',
    name: 'AsyncDlrqCompleteScreen',
  })

const DlrqQuizScreen = asyncComponent({
    resolve: () => import('./DlrqQuiz'),
    LoadingComponent,
    ErrorComponent,
    ssrMode: 'defer',
    name: 'AsyncDlrqQuizScreen',
  })


const DpResultGenerate = asyncComponent({
    resolve: () => import('./DigitalProficiency/DpReportGenerate'),
    LoadingComponent,
    ErrorComponent,
    ssrMode: 'defer',
    name: 'AsyncDpReportGenerate',
})
export {
  QuizScreen,
  StartScreen,
  DlrqQuizScreen,
  CompleteScreen,
  InformationScreen,
  InstructionsScreen,
  CommencementCheckScreen,
  LearnerFormScreen,
  DeclarationScreen,
  WelcomeBackScreen,
  IntermissionScreen,
  MissScreen,
  ErrorScreen,
  InvalidInviteScreen,
  QuizDisabledScreen,
  TrialQuizDisabledScreen,
  QuizTypeDisabledScreen,
  DlrqStartScreen,
  QuizCompleteScreen,
  QuizLearnerFormScreen,
  DlrqInfoScreen,
  DpStartScreen,
  DpLearnerFormScreen,
  DlrqCompleteScreen,
  DpQuizScreen,
  DpInfoScreen,
  DlrqLearnerFormScreen,
  DpResultGenerate,
  DpConfirmResetScreen
}



// WEBPACK FOOTER //
// ./src/screens/index.js